<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" :max-width="600" persistent content-class="round-2xl")
    v-card
      v-card-title.pa-4
        v-row(no-gutters align="center")
          v-col(cols="10" offset="1")
            div.text-lg.font-semibold.text-center.neutral700--text Switch back
          v-col(cols="1" align="right")
            v-btn(icon @click="showDialog = false" small color="primary")
              v-icon mdi-close
      v-divider
      v-card-text.pa-6
        div.text-md.font-semibold.neutral700--text You’re about to switch into old version of Registration page. The old version will be retired in a few months.
        div.text-sm.neutral700--text.mt-4 Click “Confirm” to continue
      v-divider
      v-card-actions.pb-4.pt-3.px-6
        v-spacer
        y-button.mr-3(:label="$t('cancel')" text color="neutral700" size="sm" button-class="px-0" @click="showDialog = false")
        y-button(label="Confirm" color="neutral700" size="sm" button-class="px-3" dark @click="switchOldVersion")
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('user', ['member']),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    switchOldVersion() {
      let params = {
        extra_data: {
          ...this.member.extra_data,
          new_registration: false
        }
      }
      this.$axios.patch(`/members/${this.member.id}/`, params)
          .then(resp => {
            this.$store.commit('user/setMember', resp.data)
            this.$emit('downgraded')
            this.showDialog = false
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
    }
  }
}
</script>

<style scoped>

</style>